import { Size, TextIconColor } from '../../constants';
import { withLink } from '../../hocs';
import {
  Typography,
  TypographyCasing,
  TypographyFont,
  TypographySize,
  TypographyWeight
} from '../../Typography';
import { TypographyTransition } from '../../Typography/Typography.consts';
import { TabNavigatorSize } from '../TabNavigator.consts';
import { tabOptionHighlightStyles } from '../TabNavigator.styles';

const TAB_SIZE_TO_STYLES_MAP = {
  [Size.SMALL]: {
    weight: TypographyWeight.NORMAL,
    size: TypographySize.SMALL
  },
  [Size.LARGE]: {
    weight: TypographyWeight.NORMAL,
    size: TypographySize.MEDIUM
  }
} as const satisfies Record<TabNavigatorSize, object>;

export interface TabOption<TabValue> {
  label: string;
  value: TabValue;
  href?: string;
}

interface TabOptionProp<TabValue> {
  isSelected: boolean;
  tabOption: TabOption<TabValue>;
  onClick?: ((tab: TabValue) => void) | undefined;
  size?: TabNavigatorSize;
}

const TabNavigatorOption = <TabValue,>({
  tabOption,
  onClick,
  isSelected,
  size = Size.LARGE
}: TabOptionProp<TabValue>) => {
  const { size: textSize, weight: textWeight } = TAB_SIZE_TO_STYLES_MAP[size];

  const highlightClasses = tabOptionHighlightStyles({
    isSelected,
    tabSize: size
  });

  const tabElement = (
    <div
      className={highlightClasses}
      data-testid={`tab-navigator-option-${String(tabOption.value)}`}
      onClick={() => onClick?.(tabOption.value)}
    >
      <Typography
        casing={TypographyCasing.UPPERCASE}
        color={TextIconColor.PRIMARY}
        font={TypographyFont.INTERACTIVE}
        size={textSize}
        transition={TypographyTransition.COLORS}
        weight={textWeight}
      >
        {tabOption.label}
      </Typography>
    </div>
  );

  return withLink(tabElement, { href: tabOption.href });
};

export default TabNavigatorOption;
